export function isDefaultModuleLocation() {
  return window.location.host === process.env.VUE_APP_MODULE_DEFAULT_DOMAIN;
}

export function entityUuidFromLocation() {
  //uuid after /page/ route is not entity uuid
  let url = window.location.href.split('/page/')[0].split('/');
  let uuid = url[2]; //domain by default

  const isDefaultLocation = isDefaultModuleLocation();

  if (!isDefaultLocation) {
    return uuid; //return url[2] when not default location
  }

  for (let i in url) {
    //first match
    var match = url[i].match(/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/);
    if (match) {
      uuid = match[0];
      break;
    }
  }

  return uuid;
}
